import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { QRCodeSVG } from "qrcode.react";
import { Printer } from "lucide-react";

export const QRSheet = ({ open, onOpenChange, lounges = [] }) => {
  const base = typeof window !== "undefined" ? window.location.origin : "";
  const code = (l) => (l.type === "umbrella" ? "U" : l.type === "villa" ? "V" : "G") + (l.num ?? "");
  const print = () => {
    document.body.classList.add("printing-qr");
    window.print();
    setTimeout(() => document.body.classList.remove("printing-qr"), 600);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85vh] max-w-3xl overflow-y-auto" data-testid="qr-sheet">
        <style>{`@media print { body.printing-qr * { visibility: hidden !important; } body.printing-qr #qr-print-area, body.printing-qr #qr-print-area * { visibility: visible !important; } body.printing-qr #qr-print-area { position: absolute; inset: 0; padding: 16px; } }`}</style>
        <DialogHeader>
          <DialogTitle className="font-display text-2xl tracking-wide">Spot QR codes</DialogTitle>
          <DialogDescription>Print and stick one on each spot — scanning opens that spot's menu.</DialogDescription>
        </DialogHeader>
        <button data-testid="qr-print-btn" onClick={print}
          className="mb-3 flex items-center gap-2 self-start rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-700">
          <Printer size={15} /> Print all
        </button>
        <div id="qr-print-area" className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {lounges.map((l) => (
            <div key={l.id} className="flex flex-col items-center rounded-xl border border-sand-300 bg-white p-3">
              <p className="mb-1 font-display text-xs font-bold uppercase tracking-[0.25em] text-brand-700">TRIBE</p>
              <QRCodeSVG value={`${base}/menu/${l.id}`} size={118} />
              <p className="mt-2 font-display text-lg font-bold text-slate-900">{code(l)}</p>
              <p className="text-[10px] text-slate-400">{l.label} · Beach menu</p>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
